module.exports = __webpack_public_path__ + "static/media/photoshop.b2cdc3f9.png";